"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidByType = isValidByType;

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _isString = _interopRequireDefault(require("lodash/isString"));

var _ValidatorsByType = _interopRequireDefault(require("./ValidatorsByType"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function hasNoValue(value) {
  return (0, _isString["default"])(value) && value.length === 0 || (0, _isNil["default"])(value);
} // eslint-disable-next-line complexity


function isValidByType(type, value, isRequired) {
  if (isRequired && hasNoValue(value)) {
    return false;
  }

  if (!isRequired && hasNoValue(value)) {
    return true;
  }

  var defaultValidator = function defaultValidator() {
    return true;
  };

  var typeValidator = _ValidatorsByType["default"][type] || defaultValidator;
  return typeValidator(value);
}